<template>
    <div class="promotional-code" :class="{'active': active}">
        <p class="promo">
            {{promotionalCode.show_data.total.duration}}
            {{$tc(`subscription.periods.${promotionalCode.show_data.total.duration_type}`, promotionalCode.show_data.total.duration)}} {{$t(`subscription.promo_type.commercial.${promotionalCode.type}`)}}
            <span class="asterisk">
                *
            </span>
        </p>
    </div>
</template>
<script>
    import Spinner from "../Spinner";

    export default {
        components: {
            Spinner
        },
        props: {
            promotionalCode: {
                type: Object,
                required: true,
            },
            active: {
                required: false,
                type: Boolean,
                default: false,
            }
        },
    }
</script>
<style scoped lang="scss">
    @import '../../styles/classes';

    .promotional-code{
        @extend %plan-button;
    }
</style>